import { ProductPartStatusEnum } from '@/schemas/productPartStatusEnumSchema'
import { ProductStockEnum } from '@/schemas/productStockEnumSchema'

export const isProductNonStockAndPhased = (
  productStock?: string | null,
  productPartStatus?: string | null
): boolean => {
  return (
    productStock === ProductStockEnum.NON_STOCK_WITHOUT_QUANTITY &&
    (productPartStatus === ProductPartStatusEnum.P || productPartStatus === ProductPartStatusEnum.D)
  )
}
